const ReparaturConstants = {
  GET_RUECKMELDUNGVORLAGE_SUCCESS: 'GET_RUECKMELDUNGVORLAGE_SUCCESS',
  GET_RUECKMELDUNGVORLAGE_FAILURE: 'GET_RUECKMELDUNGVORLAGE_FAILURE',
  GET_REPARTURLIST_SUCCES: 'GET_REPARTURLIST_SUCCES',
  GET_REPARTURLIST_FAILURE: 'GET_REPARTURLIST_FAILURE',
  ADD_REPARATUR_SUCCESS: 'ADD_REPARATUR_SUCCESS',
  ADD_REPARATUR_FAILURE: 'ADD_REPARATUR_FAILURE'
};
export default ReparaturConstants;
